var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"page-box",attrs:{"background":"","current-page":_vm.childMsg.currentNum,"page-sizes":[10, 25,50,100],"page-size":_vm.childMsg.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.childMsg.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }